@let pro = progress() > 100 ? 100 : progress();
@let text = type() === '%' ? (pro | number: '1.0-0') + type() : (pro | number: '1.0-0') + ' ' + type();

<div class="bg-gray-slate-transparent relative h-3 rounded-full">
  <!-- progress bar -->
  <div
    class="absolute top-0 left-0 h-full rounded-full transition-all duration-500"
    [ngStyle]="{ width: pro + '%', background: getProgressColor(pro) }"></div>

  <!-- text + circle -->
  @let left = pro > 90 ? 'auto' : 'calc(' + pro + '% - 0.5rem)';
  @let right = pro > 90 ? 'calc(' + (100 - pro) + '% - 0.5rem)' : 'auto';
  <div
    class="absolute top-1/2 flex -translate-y-1/2 items-center gap-1 transition-all duration-500"
    [class.flex-row-reverse]="pro > 90"
    [ngStyle]="{ left, right }">
    <!-- circle -->
    <div
      class="h-4 w-4 shrink-0 rounded-full border-2 border-white shadow-lg"
      [ngStyle]="{ background: getProgressColor(pro) }"></div>

    <!-- text -->
    <span class="text-xs leading-none font-semibold whitespace-nowrap">
      {{ text }}
    </span>
  </div>
</div>
